import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-9dc32372")
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = {
  class: "modal__body",
  ref: "modal"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Persoon zoeken", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Zoek hieronder naar de naam van de persoon, en klik vervolgens op de persoon die je wil toevoegen.", -1)
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 0,
  style: {"margin-top":"16px","margin-bottom":"8px"}
}
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "search-results" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "person-button__photo" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "person-button__name" }
const _hoisted_13 = {
  key: 0,
  class: "person-button__birthdate"
}
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "Er zijn geen resultaten voor deze zoekopdracht.", -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 3,
  style: {"margin-top":"16px"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "Indien de gezochte persoon niet vindbaar is, klik dan op de knop hieronder om deze persoon toe te voegen. Controleer goed of je de persoon echt niet kan vinden, om zo dubbele personen te voorkomen.", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("h1", null, "Nieuw persoon toevoegen", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("p", null, "Voer de velden hieronder zoveel mogelijk volledig in, indien deze gegevens bekend zijn. Laat een veld leeg als het onbekend is of niet van toepassing is.", -1)
const _hoisted_21 = { style: {"display":"grid","grid-template-columns":"1fr 1fr","column-gap":"16px","row-gap":"16px"} }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h2", { style: {"grid-column":"span 2"} }, "Algemeen", -1)
const _hoisted_23 = {
  class: "field",
  style: {"grid-column":"span 2"}
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", null, "Geslacht", -1)
const _hoisted_25 = { class: "radios" }
const _hoisted_26 = { class: "radio" }
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Man ")
const _hoisted_28 = { class: "radio" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Vrouw ")
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h2", { style: {"grid-column":"span 2"} }, "Naam", -1)
const _hoisted_31 = { class: "field" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { for: "firstNames" }, [
  /*#__PURE__*/_createTextVNode("Voornamen "),
  /*#__PURE__*/_createElementVNode("em", null, "(inclusief doopnamen)")
], -1)
const _hoisted_33 = { class: "field" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { for: "nickname" }, "Roepnaam", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { for: "lastName" }, "Achternaam", -1)
const _hoisted_36 = {
  key: 0,
  class: "field"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { for: "maidenName" }, "Meisjesnaam", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h2", { style: {"grid-column":"span 2"} }, "Datums", -1)
const _hoisted_39 = { class: "field" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { for: "bornAt" }, [
  /*#__PURE__*/_createTextVNode("Geboren op "),
  /*#__PURE__*/_createElementVNode("em", null, "(DD-MM-YYYY)")
], -1)
const _hoisted_41 = { class: "field" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", { for: "bornIn" }, [
  /*#__PURE__*/_createTextVNode("Geboren in "),
  /*#__PURE__*/_createElementVNode("em", null, "(plaatsnaam)")
], -1)
const _hoisted_43 = { class: "field" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { for: "diedAt" }, [
  /*#__PURE__*/_createTextVNode("Overleden op "),
  /*#__PURE__*/_createElementVNode("em", null, "(DD-MM-YYYY)")
], -1)
const _hoisted_45 = { class: "field" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { for: "diedIn" }, [
  /*#__PURE__*/_createTextVNode("Overleden in "),
  /*#__PURE__*/_createElementVNode("em", null, "(plaatsnaam)")
], -1)
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { style: {"grid-column":"span 2"} }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "button is-green",
    type: "submit"
  }, "Toevoegen")
], -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Teleport, { to: ".modals" }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "modal__close",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onCancelClick && _ctx.onCancelClick(...args)), ["prevent"]))
        }, "Annuleren"),
        (!_ctx.flags.addNewPerson)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_3,
              _hoisted_4,
              _createElementVNode("form", {
                novalidate: "",
                autocomplete: "off",
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSearchSubmit && _ctx.onSearchSubmit(...args)), ["prevent"])),
                style: {"display":"flex"}
              }, [
                _withDirectives(_createElementVNode("input", {
                  class: "control",
                  placeholder: "Zoekopdracht...",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchQuery = $event)),
                  ref: "searchQueryField"
                }, null, 512), [
                  [_vModelText, _ctx.searchQuery]
                ]),
                _createElementVNode("button", {
                  class: "button is-green",
                  style: {"margin-left":"16px"},
                  disabled: _ctx.loading
                }, "Zoeken", 8, _hoisted_5)
              ], 32),
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.searchResults)
                      ? (_openBlock(), _createElementBlock("h2", _hoisted_6, "Zoekresultaten (" + _toDisplayString(_ctx.searchResults.length) + ")", 1))
                      : _createCommentVNode("", true),
                    (_ctx.searchResults && _ctx.searchResults.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (searchResult) => {
                              return (_openBlock(), _createElementBlock("button", {
                                class: "person-button",
                                onClick: _withModifiers(($event: any) => (_ctx.onPersonClick(searchResult)), ["prevent"])
                              }, [
                                _createElementVNode("div", _hoisted_10, [
                                  (searchResult.picture)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        src: _ctx.getPictureForPerson(searchResult)
                                      }, null, 8, _hoisted_11))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", null, [
                                  _createElementVNode("span", _hoisted_12, _toDisplayString(searchResult.nickname || searchResult.firstNames) + " " + _toDisplayString(searchResult.lastName) + _toDisplayString(searchResult.maidenName && searchResult.maidenName.length > 0 ? `-${searchResult.maidenName}` : ''), 1),
                                  (searchResult.bornAt && searchResult.bornAt.length)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.showDate(searchResult.bornAt)), 1))
                                    : _createCommentVNode("", true)
                                ])
                              ], 8, _hoisted_9))
                            }), 256))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.searchResults && _ctx.searchResults.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
                      : _createCommentVNode("", true),
                    (_ctx.flags.hasSearched)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("button", {
                            class: "button is-green",
                            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.flags.addNewPerson = true), ["prevent"]))
                          }, "Nieuwe persoon toevoegen")
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_19,
              _hoisted_20,
              _createElementVNode("form", {
                novalidate: "",
                autocomplete: "off",
                onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, [
                    _hoisted_24,
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("label", _hoisted_26, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          name: "gender",
                          value: "MALE",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.fields.gender = $event))
                        }, null, 512), [
                          [_vModelRadio, _ctx.fields.gender]
                        ]),
                        _hoisted_27
                      ]),
                      _createElementVNode("label", _hoisted_28, [
                        _withDirectives(_createElementVNode("input", {
                          type: "radio",
                          name: "gender",
                          value: "FEMALE",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.fields.gender = $event))
                        }, null, 512), [
                          [_vModelRadio, _ctx.fields.gender]
                        ]),
                        _hoisted_29
                      ])
                    ])
                  ]),
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _withDirectives(_createElementVNode("input", {
                      class: "control",
                      id: "firstNames",
                      type: "text",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.fields.firstNames = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.fields.firstNames]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _hoisted_34,
                    _withDirectives(_createElementVNode("input", {
                      class: "control",
                      id: "nickname",
                      type: "text",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.fields.nickname = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.fields.nickname]
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "field",
                    style: _normalizeStyle(`grid-column: span ${_ctx.fields.gender === 'FEMALE' ? '1' : '2'}`)
                  }, [
                    _hoisted_35,
                    _withDirectives(_createElementVNode("input", {
                      class: "control",
                      id: "lastName",
                      type: "text",
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.fields.lastName = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.fields.lastName]
                    ])
                  ], 4),
                  (_ctx.fields.gender === 'FEMALE')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _hoisted_37,
                        _withDirectives(_createElementVNode("input", {
                          class: "control",
                          id: "maidenName",
                          type: "text",
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.fields.maidenName = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.fields.maidenName]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_38,
                  _createElementVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _withDirectives(_createElementVNode("input", {
                      class: "control",
                      id: "bornAt",
                      type: "text",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.fields.bornAt = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.fields.bornAt]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _hoisted_42,
                    _withDirectives(_createElementVNode("input", {
                      class: "control",
                      id: "bornIn",
                      type: "text",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.fields.bornIn = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.fields.bornIn]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _hoisted_44,
                    _withDirectives(_createElementVNode("input", {
                      class: "control",
                      id: "diedAt",
                      type: "text",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.fields.diedAt = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.fields.diedAt]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _hoisted_46,
                    _withDirectives(_createElementVNode("input", {
                      class: "control",
                      id: "diedIn",
                      type: "text",
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.fields.diedIn = $event))
                    }, null, 512), [
                      [_vModelText, _ctx.fields.diedIn]
                    ])
                  ]),
                  _hoisted_47
                ])
              ], 32)
            ], 64))
      ], 512)
    ])
  ]))
}